import { render, staticRenderFns } from "./DmPendingNearMatchOverviewRow.vue?vue&type=template&id=0303a36d&scoped=true&"
import script from "./DmPendingNearMatchOverviewRow.vue?vue&type=script&lang=js&"
export * from "./DmPendingNearMatchOverviewRow.vue?vue&type=script&lang=js&"
import style0 from "./DmPendingNearMatchOverviewRow.vue?vue&type=style&index=0&id=0303a36d&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0303a36d",
  null
  
)

export default component.exports